import React from 'react';
import { Wallet, Sparkles, Unlock, Truck, Plane, TrendingUp, Percent, CalendarCheck, Users, ShieldCheck, ExternalLink, Briefcase, CheckCircle2 } from 'lucide-react';
const benefits = [{
  title: 'Low Risk Start',
  description: 'Only $75 to become a distributor and have your own GNLD business!',
  icon: Wallet
}, {
  title: 'Effective Products',
  description: 'The products are so effective they sell themselves! High retention and reorders.',
  icon: Sparkles
}, {
  title: 'No Quotas',
  description: 'No minimum orders. No monthly quotas. No purchase requirements.',
  icon: Unlock
}, {
  title: 'No Inventory',
  description: 'No inventories needed. NeoLife will drop ship directly to your customers.',
  icon: Truck
}, {
  title: 'Travel & Bonuses',
  description: 'Earn Car bonuses and Free trips to different destinations.',
  icon: Plane
}, {
  title: 'Top Compensation',
  description: 'One of the best Compensation plans available in the business.',
  icon: TrendingUp
}, {
  title: 'High Margins',
  description: 'Make 25% profit off each product you sell.',
  icon: Percent
}, {
  title: 'Monthly Income',
  description: 'Get a bonus check every month based on the amount of products sold.',
  icon: CalendarCheck
}, {
  title: 'Community Support',
  description: 'Great Support team, connections and relationships to help you grow.',
  icon: Users
}, {
  title: 'Financial Security',
  description: 'Build financial security, peace of mind and much more!',
  icon: ShieldCheck
}];
export function DistributorPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-365">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-366">
        <div className="max-w-4xl mx-auto text-center" data-id="element-367">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-368">
            <Briefcase className="w-10 h-10 text-[#0e7be1]" data-id="element-369" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-370">
              Become a Promoter
            </h1>
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mt-4" data-id="element-371">
            Learn more about the GNLD NeoLife Opportunity
          </p>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full mt-8" data-id="element-372"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-373">
        {/* Intro Section */}
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-374">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-375">
            GNLD Distributors - NeoLife Information
          </h2>
          <div className="bg-blue-50 rounded-2xl p-8 border border-blue-100" data-id="element-376">
            <p className="text-lg md:text-xl text-gray-800 font-medium leading-relaxed mb-4" data-id="element-377">
              GNLD has been in business since 1958 and is still thriving! It's a
              real business making thousands of people healthy and financially
              free!
            </p>
            <p className="text-lg text-[#0e7be1] font-bold" data-id="element-378">
              Can you trust a company that has a spotless reputation for so
              long?
            </p>
          </div>

          <div className="mt-10" data-id="element-379">
            <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#1a8f3c] hover:bg-[#157a32] text-white text-lg md:text-xl font-bold px-8 py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5" data-id="element-380">
              Click here to join GNLD NeoLife Now!
              <ExternalLink className="w-5 h-5" data-id="element-381" />
            </a>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="mb-20" data-id="element-382">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-383">
            10 Benefits of Becoming a Distributor
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-384">
            {benefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 hover:border-[#0e7be1]/30 group" data-id="element-385">
                <div className="flex items-start gap-4" data-id="element-386">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center text-[#0e7be1] group-hover:bg-[#0e7be1] group-hover:text-white transition-colors duration-200" data-id="element-387">
                    <benefit.icon className="w-6 h-6" data-id="element-388" />
                  </div>
                  <div data-id="element-389">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-390">
                      <span className="text-[#0e7be1] opacity-60 text-sm font-mono" data-id="element-391">
                        0{index + 1}.
                      </span>
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-392">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Video Section */}
        <div className="max-w-4xl mx-auto mb-20" data-id="element-393">
          <div className="text-center mb-8" data-id="element-394">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-395">
              Watch Why Thousands Join Every Month
            </h2>
            <p className="text-gray-600" data-id="element-396">
              It may change your health and your financial situation!
            </p>
          </div>
          <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl bg-black border-4 border-white" data-id="element-397">
            <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/Qlh3L_8Qcuc?wmode=opaque" title="NeoLife Opportunity Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-398"></iframe>
          </div>
        </div>

        {/* Final CTA */}
        <div className="bg-gray-900 rounded-3xl p-8 md:p-16 text-center text-white overflow-hidden relative" data-id="element-399">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-400"></div>
          <div className="relative z-10" data-id="element-401">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-402">
              Ready to Change Your Life?
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-403">
              Join the GNLD NeoLife family today and start your journey towards
              better health and financial freedom.
            </p>
            <a href="http://shopneolife.com/lookfeelbetter/enrollment/enrollmentconfiguration" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#0e7be1] hover:bg-[#0c6bc4] text-white text-lg md:text-xl font-bold px-10 py-5 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5" data-id="element-404">
              Click here to join GNLD NeoLife Now!
              <ExternalLink className="w-5 h-5" data-id="element-405" />
            </a>

            <div className="mt-8 flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-406">
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-407" />
              <span data-id="element-408">Secure Enrollment</span>
              <span className="mx-2" data-id="element-409">•</span>
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-410" />
              <span data-id="element-411">Instant Access</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}